import {
  DialogTrigger,
  LinkButton,
  Popover,
  PopoverContent,
  SelectFormikField,
  SelectItem,
} from "@certn/cascadia-react";
import { Trans, useTranslation } from "react-i18next";

export function RescreenFrequencyDropdownFormik() {
  const { t } = useTranslation();
  const rescreenOptions = [
    { label: t("Do not rescreen"), value: "DO_NOT_RESCREEN" },
    { label: t("Weekly"), value: "WEEKLY" },
    { label: t("Monthly"), value: "MONTHLY" },
    { label: t("Quarterly"), value: "QUARTERLY" },
    { label: t("Semi-annually"), value: "SEMI_ANNUALLY" },
    { label: t("Annually"), value: "ANNUALLY" },
  ];

  return (
    <SelectFormikField
      name="rescreenFrequency"
      default={rescreenOptions[0].value}
      label={t("Rescreen frequency")}
      testID="rescreen-frequency-dropdown"
      info={
        <DialogTrigger>
          <LinkButton testID="">{t("What's this?")}</LinkButton>
          <Popover placement="top right">
            <PopoverContent>
              <Trans>
                Ensure ongoing safety and compliance by automatically
                rescreening applicants. On the scheduled date, the applicant
                will receive an email to complete another background screening,
                matching the checks of their initial order. Note, rescreening
                will be cancelled if the original or previous case was not
                completed.
              </Trans>
            </PopoverContent>
          </Popover>
        </DialogTrigger>
      }
    >
      {rescreenOptions.map((option) => {
        return (
          <SelectItem id={option.value} key={option.value}>
            {option.label}
          </SelectItem>
        );
      })}
    </SelectFormikField>
  );
}
